/* src/app/components/LoadingIndicator/index.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

import styles from './styles';

class LoadingIndicator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldRender: false,
      loading: false,
    };
  }

  componentWillReceiveProps({ loading }) {
    if (this.state.loading && !loading) this.setState({ loading, shouldRender: false });
    if (!this.state.loading && loading) {
      this.setState({ loading }, () =>
        setTimeout(() => {
          if (this.state.loading) this.setState({ shouldRender: true });
        }, 1000));
    }
  }

  render() {
    const { shouldRender, loading } = this.state;
    if (!(shouldRender && loading)) return null;

    const { classes } = this.props;
    return (
      <div className={classes.overlay}>
        <CircularProgress />
      </div>
    );
  }
}

LoadingIndicator.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default withStyles(styles)(LoadingIndicator);



// WEBPACK FOOTER //
// ./src/app/components/LoadingIndicator/index.js